export default __webpack_public_path__ + "static/media/icon-vouchers-inverted.25041cdb.svg";